module.exports = __webpack_public_path__ + "static/group2_1-593f94bf9b6296752a21bc34fa421cf1.webp";